import type { WheelEvent } from "react";

export function stopOverlayWheelPropagation(
  event: WheelEvent<HTMLElement>,
): void {
  event.stopPropagation();
}
